import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.cashierRegistryFoodPage.setFetching(isFetching)

const fetchData = ({ classId, fromInt, toInt }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const {
    me: { id },
    marketplace: { accessLevel: { edu, rpc } },
  } = getState()
  const { cashierAccessLevel } = !isRpc ? edu : rpc

  const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id

  const url = classId
    ? prefix.statClass + `/${classId}`
    : prefix.statSchool + `/${schoolId}`

  return request.post(url, {
    fromInt,
    toInt,
  })
    .then(({ data }) => {
      if (data && data.orders.length) {
        const orders = data.orders.map(({ positions, ...order }) => ({
          ...order,
          positions: positions.reduce((result, position) => {
            const positionIndex = result.findIndex(({ nomId }) => nomId === position.nomId)

            if (positionIndex === -1) {
              result.push(position)
            }
            else {
              result[positionIndex] = {
                ...result[positionIndex],
                days: result[positionIndex].days.concat(position.days),
              }
            }

            return result
          }, [])
        }))

        return {
          ...data,
          orders,
        }
      }

      return data
    })
    .then((data) => reducers.marketplace.cashierRegistryFoodPage.setData(data))
    .catch((error) => console.log(error))
}

const fetchClasses = () => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  const {
    me: { id },
    marketplace: { accessLevel: { edu, rpc } },
  } = getState()
  const { cashierAccessLevel } = !isRpc ? edu : rpc

  const schoolId = cashierAccessLevel.find(({ cashier }) => id === cashier.id).school.id

  return request.get(prefix.schools + `/${schoolId}?all=false`)
    .then(({ data }) => data)
    .then((classes) => (
      classes
        .sort((a, b) => {
          if (a.grade === b.grade) {
            return a.letter < b.letter ? -1 : a.letter > b.letter ? 1 : 0
          }

          return a.grade < b.grade ? -1 : a.grade > b.grade ? 1 : 0
        })
    ))
    .then((classes) => {
      reducers.marketplace.cashierRegistryFoodPage.setClasses(classes)
    })
    .catch((error) => {
      console.log(error)
    })
}


export default {
  setFetching,
  fetchData,
  fetchClasses,
}
